// components
import Button from '@drivesally/sally-ui/lib/components/Button/Button';
import DropDown from '@drivesally/sally-ui/lib/components/DropDown/DropDown';
import Icon from '@drivesally/sally-ui/lib/components/Icon/Icon';
import Input from '@drivesally/sally-ui/lib/components/Input/Input';
import SimpleMenu from '@drivesally/sally-ui/lib/components/SimpleMenu/SimpleMenu';

// date lib
import convertHoursIntoHourMinutes from '../../../date/lib/convertHoursIntoHourMinutes.lib.date';

// layout components
import CompactDataRow from '../../../layout/components/CompactDataRow/CompactDataRow';

// local components
import AddBlock from './components/AddBlock';
import Container from './components/Container';
import Day from './components/Day';
import Hour from './components/Hour';
import Limit from './components/Limit';
import Remove from './components/Remove';
import Row from './components/Row';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

const hourLabel = (hour) =>
  `${convertHoursIntoHourMinutes(Number(hour))} - ${convertHoursIntoHourMinutes(
    (Number(hour) + 1) % 24
  )}`;

class AppReservationsPerHourDayEditor extends Component {
  static propTypes = {
    day: PropTypes.string.isRequired,
    hours: PropTypes.object,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    hours: {},
  };

  state = {
    hourDropDownOpen: false,
  };

  // Picking an hour counts as a click outside the drop down, which closes it, so reopen it to keep picking hours
  toggleHour = (hour) => {
    const {hours, onChange} = this.props;
    const {[hour]: removed, ...remainingHours} = hours;
    onChange(hour in hours ? remainingHours : {...hours, [hour]: ''});
    this.setState({hourDropDownOpen: true});
  };

  changeLimit = (hour) => (limit) => {
    const {hours, onChange} = this.props;
    onChange({...hours, [hour]: limit});
  };

  removeHour = (hour) => () => {
    const {hours, onChange} = this.props;
    const {[hour]: removed, ...remainingHours} = hours;
    onChange(remainingHours);
  };

  render() {
    const {day, hours} = this.props;
    const {hourDropDownOpen} = this.state;
    const sortedHours = Object.keys(hours).sort(
      (a, b) => Number(a) - Number(b)
    );
    const hourOptions = [...Array(24).keys()].map((option) => ({
      value: `${option}`,
      label: hourLabel(option),
    }));
    return (
      <CompactDataRow label={<Day>{day}</Day>}>
        <Container>
          {sortedHours.map((existingHour) => (
            <Row key={existingHour}>
              <Hour>
                <Button theme="grey" size="small" block>
                  {hourLabel(existingHour)}
                </Button>
              </Hour>
              <Limit>
                <Input
                  value={`${hours[existingHour]}`}
                  onChange={this.changeLimit(existingHour)}
                  size="small"
                  placeholder="#"
                />
              </Limit>
              <Remove>
                <Icon onClick={this.removeHour(existingHour)} icon="delete" />
              </Remove>
            </Row>
          ))}
          {!sortedHours.length && (
            <div>No overrides, every hour allows the default</div>
          )}
          <Hour>
            <DropDown
              onOpen={() => this.setState({hourDropDownOpen: true})}
              onClose={() => this.setState({hourDropDownOpen: false})}
              trigger={<AddBlock>+ Add hours</AddBlock>}
              visible={hourDropDownOpen}
              size={170}
              block
            >
              <SimpleMenu
                height={200}
                selected={sortedHours}
                options={hourOptions}
                onSelect={this.toggleHour}
                noDataLabel="No hours available"
              />
            </DropDown>
          </Hour>
        </Container>
      </CompactDataRow>
    );
  }
}

export default AppReservationsPerHourDayEditor;
